export default {
  wasHelpful: 'Was this helpful?',
  yes: 'Yes',
  no: 'No',
};
